module.exports = __webpack_public_path__ + "static/media/adobeaudition.f6d6a8cb.svg";